
module.exports = function (AppId, multiInstance=false) {
    var settingsObj = {
        settings: []
    };
    AppId = AppId.toLocaleLowerCase();    

    var settings = {};
    var attributeName = 'data-'+AppId;
    var mountPoints = document.querySelectorAll("[" + attributeName + "]");  
    if(mountPoints.length > 0){
        if(multiInstance){
            for(var i=0;i<mountPoints.length;i++){
                settings = GetNodeSettings(AppId, mountPoints[i]);
                var appNameId = mountPoints[i].attributes[attributeName].value;
                settingsObj.settings[i] = settings;
            }
        }
        else{
            settings = GetNodeSettings(AppId, mountPoints[0]);
        }
    }

    if(multiInstance){
        return settingsObj;
    }
    else{
        return settings;
    }
    
}

function GetNodeSettings(AppId, mountPoints){
    var settings = {};
    let attributes = mountPoints.attributes;
    if(attributes.length > 0){
        for(let j=0;j<attributes.length;j++){
            let attribute = attributes[j]
            if(attribute.name.substr(0,5) == "data-"){
                let name = attribute.name.substr(5);
                var value = attribute.value;
                
                if(name == AppId.toLocaleLowerCase()){
                    mountPoints.setAttribute("id",value);
                }
                var temp = name.split('.');
                if (temp.length == 2) {
                    if (settings[temp[0]] == undefined) {
                        settings[temp[0]] = {};
                    }
                    settings[temp[0]][temp[1]] = value;
                }
                else if (temp.length == 3) {
                    if (settings[temp[0]] == undefined) {
                        settings[temp[0]] = {};
                    }
                    if (settings[temp[0]][temp[1]] == undefined) {
                        settings[temp[0]][temp[1]] = {};
                    }
                    settings[temp[0]][temp[1]][temp[2]] = value;
                }
                else {
                    settings[temp[0]] = value;
                }

            }
        }
    }
    return settings;
}